import React from 'react';
import ShoppingCart from '../components/ShoppingCart';
import { Container, Typography } from '@mui/material';

function CartPage({ cart, totalCost, removeFromCart, clearCart, handleCheckout }) {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Shopping Cart
      </Typography>
      {cart.length > 0 ? (
        <ShoppingCart cart={cart} totalCost={totalCost} removeFromCart={removeFromCart} clearCart={clearCart} handleCheckout={handleCheckout} />
      ) : (
        <Typography>Your cart is empty.</Typography>
      )}
    </Container>
  );
}

export default CartPage;
